type RoleLevel = "org" | "project";

/**
 * Well-known role key constants. The org role catalog is backend-driven and may
 * also surface custom roles, so a role's `key` stays `string`; use these
 * constants whenever the frontend names a specific built-in role (default
 * selections, self-demotion checks, per-role styling).
 */
export const ROLE = {
  orgAdmin: "org_admin",
  projectAdmin: "project_admin",
  projectMember: "project_member",
} as const;

export type BuiltinRoleKey = (typeof ROLE)[keyof typeof ROLE];

/**
 * A role as it appears attached to a member or invitation (the backend `RoleRef`).
 * `container` is intentionally omitted — the UI never needs it.
 */
export type RoleRef = {
  key: string;
  display_name: string;
  level: RoleLevel;
  builtin: boolean;
};

/** A selectable role from the org role catalog (`GET /authz/roles`). */
export type RoleCatalogEntry = {
  key: string;
  display_name: string;
  level: RoleLevel;
  builtin: boolean;
  editable: boolean;
  invitable: boolean;
};

type RolesData = {
  roles: RoleCatalogEntry[];
};

export type RolesResponse = {
  code: number;
  msg: string;
  data: RolesData;
};
